var _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuestion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1833_7975",
    transform: "scale(0.05)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1833_7975",
    width: 20,
    height: 20,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAFKADAAQAAAABAAAAFAAAAACy3fD9AAACwUlEQVQ4EYVVy0tiURj/vD6a8bEwbBY+wDahQrQIp0WDDWIrYWhgFjGrFtqiTUb9DW6KooWBroSW0WJ2QYM0swqmhQQ+ghlwSCtGxBGLUZOc73fpio9784PLOec73/md7/U7V0UKEolEPnU6nVmTyeRvNpsumI2NjeXr9XqKpxf7+/vHckdVg8q1tTWj2Wz+NjMzY+fxjc1mI3yQUqkkftVq9c/l5eXvh4eHhb29vX+DGN01e+Xf2tpqXl1dsXMvSy6X62xubrbW19d9XYDeSTQa/RCLxf6+DDO8izMbGxsLEpYYMsLU6/WV7e1tnbSBkT2lVCpFt7e3pNVqaWpqioLBIBmNxl4z4qjalUrFlEwmGwJ2kLNwONwHVi6XKR6P083NDTmdThSEzs/P6fDwsA8Mi1AopLHb7d8xV6OaXq/3s8/nM0AhicFgIIfDQUtLS8T7ND8/T+l0mq6vr8nv95NarZZMyWKxEDugY/ufGs7KLHs40d3tmXg8nu7q6emJGo0GohHD7248T8bHxyeAJaDPpLYYNJLWbEhHR0dUq9Vobm5OUveNHDIxVkBotVruUYAnJydi/hD64uJiH5C0AAYTwCMWRVLKjff393R6ekqTk5O0vLxMKtUQF/qOCTqdLgcGKAnCRMgul4sEQfn+YrGITshqwE0GfOt2u2UxrVYr7ezsjPQMTjHWV4HLfwFuyqKxslAoEPOVzs7OlExEPWOUOR0/hN3d3WMQPZ/Pyx5Aq+B2hK4k2WyWMpnML774i2jDXHwNonOuZIV7sINPSfh8e3V1VQswMct4gtrtduDg4EDWDVRWqbr8ONT4sveJROJxKAK8GuzpI56mUcIhduAZP1/veoGGmmplZeUViD49Pe0EJcEAqfHRGsgnCoCc3d3d+QY9GwKUbuPbP7KX+AUEwADo0WdoDVSzWwDpwPP4H5+a1+CKjmXjAAAAAElFTkSuQmCC"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.d1f64a8b77750c44ed1bc5c51fe50bac.svg";
export { ForwardRef as ReactComponent };